/* eslint-disable */
import React, { Component } from 'react'
import { Segment, Header, Form, Button } from "semantic-ui-react"
import { update } from '../../../data/user_api';


export default class SocOption extends Component {
  constructor (props) {
    super(props);
    this.state = {
      "Cleaned By 3rd Party (Invoice)": { checked: false, comment: null },
      "Clean": { checked: false, comment: null },
      "Further Clean Required": { checked: false, comment: null },
      "Not Clean": { checked: false, comment: null },
      "Not Applicable": { checked: false, comment: null }
    }
    
  }

  updateCategoriesCheck = (category, checked) => {
    let newState = { ...this.state }
    newState[category].checked = checked
    this.setState({ ...newState });
    this.props.updateCategory(this.props.category, { ...newState })
  }
  

  updateCategoriesComment = (category, comment) => {  
    let newState = { ...this.state }
    newState[category].comment = comment
    this.setState({ ...newState })
    this.props.updateCategory({ ...newState })
  }
    render() {
      let cleanlinessArr = ["Cleaned By 3rd Party (Invoice)", "Clean", "Further Clean Required", "Not Clean", "Not Applicable"]
      return (<span>
          {cleanlinessArr.map((cleanCat) => {
            return <React.Fragment key={cleanCat}><Button labelPosition="left" icon={this.state[cleanCat].checked?"check":"plus"} fluid color={this.state[cleanCat].checked?"blue":null}
              style={{ marginBottom: "10px" }}
              content={cleanCat}
              onClick={(e, option) => {this.updateCategoriesCheck(cleanCat, this.state[cleanCat].checked?false:true); !this.state[cleanCat].checked?this.updateCategoriesComment(cleanCat, ""):null }} />
              {this.state[cleanCat].checked && <Form.Input
                label={"Comment"}
                fluid
                onChange={(e) => { this.updateCategoriesComment(cleanCat, e.target.value);}} />}
              </React.Fragment>
          })}
        </span>)
          
  }
}




// WEBPACK FOOTER //
// ./src/views/report/soc_generator/soc_option.js